import axios from 'axios'
import cookie from "../../static/js/cookie";
let host = 'https://uukasi.com'
// let host = 'http://uukasi.com:8088'

axios.interceptors.request.use(
  config => {
    if (cookie.getCookie('token')) {
      config.headers.Authorization = cookie.getCookie('token')
    }

    return config
  },
  error => {
    return Promise.reject(error)
  })

export const uukasiLogin = params => {
  return axios.post(`${host}/login/`, params)
}
// 验证用户
export const uukasiCheckUser = params => {
  return axios.get(`${host}/checkUser/`, {params: params})
}
// 注册 短信验证注册
export const uukasiRegister = parmas => {
  return axios.post(`${host}/register/`, parmas)
}
// 短信验证码
export const uukasiCodes = parmas => {
  return axios.post(`${host}/codes/`, parmas)
}
// 忘记密码的验证码获取
export const uukasiForcodes = parmas => {
  return axios.post(`${host}/forcodes/`, parmas)
}
// 忘记密码的修改密码
export const uukasiForget = parmas => {
  return axios.post(`${host}/forget/`, parmas)
}

// 积分
export const myucasIntegral = parmas => {
  return axios.get(`${host}/integral/`, {params: parmas})
}
// 会员
export const myucasVipjuris = parmas => {
  return axios.get(`${host}/vipjuris/`, {params: parmas})
}

// 获取微信的东西
export const getSignPackage = parmas => {
  return axios.get(`${host}/getSignPackage/`, {params: parmas})
}
// 判断微信关注
export const judgeWechatFollow = parmas => {
  return axios.get(`${host}/public/userinfo/`, {params: parmas})
}
// 查询用户信息
export const queryUserDetl = params => {
  return axios.get(`${host}/user/detail/`, {params: params})
}
// 学校列表
export const univs = params => {
  return axios.get(`${host}/univs/`, {params: params})
}
// 学校详情
export const univsmain = univsId => {
  return axios.get(`${host}/univs/${univsId}` + '/')
}
// 历史沿革
export const univshist = params => {
  return axios.get(`${host}/translate/`, {params: params})
}
// 排名
export const univrank = params => {
  return axios.get(`${host}/people/`, {params: params})
}
// 学院列表
export const colleges = params => {
  return axios.get(`${host}/colleges/`, {params: params})
}
// 学院详情
export const collegesmain = collegeId => {
  return axios.get(`${host}/colleges/${collegeId}` + '/')
}
// 系列表
export const facultys = params => {
  return axios.get(`${host}/facultys/`, {params: params})
}
// 系的详情
export const facultysmain = facultysId => {
  return axios.get(`${host}/facultys/${facultysId}` + '/')
}
// 分数线列表
export const scores = params => {
  return axios.get(`${host}/scores/`, {params: params})
}
// 地区列表
export const citys = params => {
  return axios.get(`${host}/citys/`)
}
// 属性列表
export const attris = params => {
  return axios.get(`${host}/attris/`)
}
// 学校类型列表
export const univsTypes = params => {
  return axios.get(`${host}/univsTypes/`)
}
// 职业
export const industrys = params => {
  return axios.get(`${host}/industry/`)
}
// 行业
export const professionals = params => {
  return axios.get(`${host}/professional/`, {params: params})
}
// 行业详情
export const professionalDetail = industrytId => {
  return axios.get(`${host}/professional/${industrytId}` + '/')
}
// 岗位
export const jobs = params => {
  return axios.get(`${host}/jobs/`, {params: params})
}
// top公司
export const companys = params => {
  return axios.get(`${host}/company/`, {params: params})
}
// 专业(通用)
export const subs = params => {
  return axios.get(`${host}/subs/`, {params: params})
}
// 学历类别
export const education = params => {
  return axios.get(`${host}/education/`)
}
// 学科类别
export const category = params => {
  return axios.get(`${host}/category/`)
}
// 专业类别
export const stypes = params => {
  return axios.get(`${host}/stypes/`)
}
// 搜索专业模糊
export const querysubfuzzy = params => {
  return axios.get(`${host}/sub/`, {params: params})
}
// 搜索专业精准
export const querysubsure = params => {
  return axios.get(`${host}/contrast/`, {params: params})
}
// 专业
export const subjects = params => {
  return axios.get(`${host}/subjects/`, {params: params})
}
// 专业详情
export const subjectsmain = params => {
  return axios.get(`${host}/subjects/`, {params: params})
}
// 提交点击量
export const doPageView = params => {
  return axios.get(`${host}/uclick/`, {params: params})
}
// 获取学校满意度
export const univsatisRate = parmas => {
  return axios.get(`${host}/univsatis`, {params: parmas})
}

// 查询国际学校的列表
export const oveunivs = params => {
  return axios.get(`${host}/oveunivs/`, {params: params})
}

// 国际学校的收藏
export const ovefav = params => {
  return axios.get(`${host}/ovefav/`, {params: params})
}

// 国际学校的浏览量
export const oveclick = params => {
  return axios.get(`${host}/oveclick/`, {params: params})
}

// 国际学校专业方向列表
export const ovedirec = params => {
  return axios.get(`${host}/ovedirec/`, {params: params})
}

// 国际学校专业列表
export const ovesublist = params => {
  return axios.get(`${host}/ovesublist/`, {params: params})
}

// 国际学校专业详情
export const ovesubject = params => {
  return axios.get(`${host}/ovesubject/`, {params: params})
}

// 购买报告超出次数发送验证码
export const buySoManySendTest = params => {
  return axios.post(`${host}/reportc/`, params)
}
// 购买报告超出次数填写验证码
export const buySoManyTest = params => {
  return axios.post(`${host}/eenter/`, params)
}
// 生成报告订单
export const goShop = params => {
  return axios.get(`${host}/shop/`, {params: params})
}
// 最终下载报告
export const donwoladreport = params => {
  return axios.get(`${host}/enter/`, {params: params})
}
// 下载报告
export const collreport = params => {
  return axios.get(`${host}/collreport/`, {params: params})
}
// 个人订单下载报告
export const downReport = params => {
  return axios.get(`${host}/report/`, {params: params})
}
// 个人订单支付
export const shopReports = params => {
  return axios.get(`${host}/payment/`, {params: params})
}
// 个人订单列表
export const queryReportsList = params => {
  return axios.get(`${host}/univspayment/`, {params: params})
}

// 用户提交满意度测评
export const userUpSatis = parmas => {
  return axios.post(`${host}/userop/satis/`, parmas)
}
// 判断是否提交过满意度
export const useropIsSatis = parmas => {
  return axios.get(`${host}/userop/isSatis`, {params: parmas})
}
// 获取专业满意度
export const subsatis = parmas => {
  return axios.get(`${host}/subsatis`, {params: parmas})
}
// 查询分数线省份
export const univsScorecity = params => {
  return axios.get(`${host}/scorecity/`, {params: params})
}
// 查询分数线
export const univsScores = params => {
  return axios.get(`${host}/scores/`, {params: params})
}
// 查询所罗门测试结果
export const queryUnivsnews = params => {
  return axios.get(`${host}/univsnews/`, {params: params})
}
// 查询收藏
export const queryCollect = params => {
  return axios.get(`${host}/userfav/`, {params: params})
}
// 收藏/取消收藏 userop/userfav
export const doCollect = params => {
  return axios.get(`${host}/userop/userfav/`, {params: params})
}
// 职业点击量
export const jobClick = params => {
  return axios.get(`${host}/jobcl/jclick/`, {params: params})
}
// 所罗门测试一对一提交
export const solomonOneToOne = params => {
  return axios.post(`${host}/solomon/tione/`, params)
}
// 点击开始测试扣除时间
export const startSolomonTest = params => {
  return axios.get(`${host}/solomon/start/`, {params: params})
}
// 提交所罗门测试
export const submitSolomonTest = params => {
  return axios.post(`${host}/solomon/tijiao/`, params)
}
// 获取所罗门测试题目
export const querySolomonTestQuestion = params => {
  return axios.get(`${host}/solomon/quiz/`, {params: params})
}
// 查询所罗门测试需注意
export const querySolomonTestTitle = params => {
  return axios.get(`${host}/solomon/title/`, {params: params})
}
// 所罗门测试填写个人信息
export const solomonTestInformation = params => {
  return axios.post(`${host}/solomon/detail/`, params)
}
// 确认购买所罗门测试
export const buySolomonTest = params => {
  return axios.post(`${host}/solomon/enter/`, params)
}
// 查询当前所罗门测试进程（购买或者已做到哪）
export const querySolomonTestCourse = params => {
  return axios.get(`${host}/solomon/into/`, {params: params})
}
// 查询所罗门测试结果、时间
export const querySolomonTestResult = params => {
  return axios.get(`${host}/solomon/score/`, {params: params})
}
// 所罗门催单
export const reminderSolomonTest = params => {
  return axios.post(`${host}/solomon/titwo/`, params)
}
// 查询测试结果
export const queryTestResult = params => {
  return axios.get(`${host}/quizf/`, {params: params})
}
// 测评提交
export const testQuestionSub = params => {
  return axios.post(`${host}/userop/userquiz/`, params)
}
// 测试传ID查具体题目
export const testQuestionData = params => {
  return axios.get(`${host}/quiz/`, {params: params})
}
// 测试传类型或者传免费、收费查题目
export const testQuestionTittle = params => {
  return axios.get(`${host}/quizt/`, {params: params})
}
// 个人中心查询所罗门测试
export const userQuerysolomon = params => {
  return axios.get(`${host}/solomon/user/`, {params: params})
}
// 开始收费测试扣除时间
export const startTollTest = params => {
  return axios.get(`${host}/userop/quiztime/`, {params: params})
}
// 购买测试填写信息
export const tollTestInformation = params => {
  return axios.post(`${host}/userop/detail/`, params)
}
// 确认购买测试
export const buySureTollTest = params => {
  return axios.get(`${host}/enterq/`, {params: params})
}
// 购买测试
export const buyTollTest = params => {
  return axios.get(`${host}/payquiz/`, {params: params})
}
// 一对一测试结果列表
export const oneToOneResult = params => {
  return axios.get(`${host}/oneuser/`, {params: params})
}
// 加急一对一测试
export const oneToOnecomeOn = params => {
  return axios.get(`${host}/quizone/hot/`, {params: params})
}
// 查询是否填写个人信息
export const queryIsInformation = params => {
  return axios.get(`${host}/paydetail/`, {params: params})
}
// 一对一填写个人信息
export const oneToOneInformation = params => {
  return axios.get(`${host}/quizone/start/`, {params: params})
}
// 确认购买一对一
export const buyOneToOne = params => {
  return axios.post(`${host}/quizone/enter/`, params)
}
// 查询一对一进程
export const queryOnetoOnePros = params => {
  return axios.get(`${host}/quizone/pay/`, {params: params})
}
// 查询所罗门测试结果
export const Querysolomonresult = params => {
  return axios.get(`${host}/solomon/ones/`, {params: params})
}
// 获取封面图
export const imgPath = params => {
  return axios.get(`${host}/imgPath/`, {params: params})
}
export const imageCollect = (params) => {
  return axios.get(`${host}/image-collect/`, {params: params})
}
// 查找一次聊天记录
export const serviceHistory = (params) => {
  return axios.get(`https://yookasi.com:9005/service/history`, {params: params})
}
// 客服地方引导内容的列表
export const serviceGuide = (params) => {
  return axios.get(`https://yookasi.com:9005/service/guide/`, {params: params})
}
// 退出登录时长
export const logoutTime = params => {
  return axios.get(`${host}/logout-time/`, {params: params})
}
// 上传图片   文章专栏
export const PImg = parmas => {
  return axios.post(`${host}/pimg/`, parmas)
}
//举报-新
export const complaintAll = parmas => {
  return axios.post(`${host}/complaint-all/`, parmas)
}
//敏感词列表
export const sensitiveWords = params => {
  return axios.get(`${host}/sensitive-words/`, {params: params})
}
// 系统通知
export const usersManage = params => {
  return axios.get(`${host}/users/manage/`, {params: params})
}
// 系统通知归零
export const usersMaclear = params => {
  return axios.get(`${host}/users/maclear/`, {params: params})
}
//网站展示开关
export const siteSwitch = (params) => {
  return axios.get(`${host}/site-switch/`, {params: params})
}



// WEBPACK FOOTER //
// ./src/config/axioUtilUcas.js